export default {
  APP_EPOCH: new Date('2016-05-01')
}
